export interface IRocketIcon {
  color?: string;
}
export default function RocketIcon(props: IRocketIcon) {
  return (
    <svg width="22" height="22" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        id="Vector"
        d="M9.47092 4.95711C10.4547 4.05449 11.7413 3.55371 13.0765 3.55371L13.3339 3.55371V3.81113C13.3339 5.14629 12.8331 6.43288 11.9305 7.41671L7.83038 11.8856L5.00195 9.05721L9.47092 4.95711Z"
        stroke={props.color ?? 'var(--app-light)'}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M5.33268 11.5537L3.66602 13.2204"
        stroke={props.color ?? 'var(--app-light)'}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M6.66732 12.8867L6.33398 13.2201"
        stroke={props.color ?? 'var(--app-light)'}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_4"
        d="M3.99935 10.2197L3.66602 10.5531"
        stroke={props.color ?? 'var(--app-light)'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_5"
        d="M9.16732 13.2197L9.99398 9.71973L7.83398 11.8864L9.16732 13.2197Z"
        stroke={props.color ?? 'var(--app-light)'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_6"
        d="M4.99935 9.05339L7.16602 6.88672L3.66602 7.55339L4.99935 9.05339Z"
        stroke={props.color ?? 'var(--app-light)'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
